import {combineReducers} from 'redux'
import deposit from './reducers/deposit'
import start from './reducers/start'
import timeslot from './reducers/calendar'
import address from './reducers/address'
import paymentMethod from './reducers/paymentMethod'
import review from './reducers/review'
import summary from './reducers/summary'
import costs from './reducers/costs'
import phone from './reducers/phone'

export default combineReducers({
  deposit,
  start,
  timeslot,
  address,
  paymentMethod,
  review,
  summary,
  costs,
  phone,
})



// WEBPACK FOOTER //
// ./src/sections/depositV2/reducer.js